// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';

// Model imports
import { WFVendorNotesResultDto } from '../_models/wf-vendor-notes-result-dto';
import { WFVendorNotesParameterDto } from '../_models/wf-vendor-notes-parameter-dto';
import { SaveCommunityVendorNotesParametersDto } from '../_models/save-community-vendor-notes-parameters-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';

@Injectable({
    providedIn: 'root'
})
export class VendorSharedService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getVendorNotes(baseParams: WFVendorNotesParameterDto): Observable<WFVendorNotesResultDto> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/notes${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get<WFVendorNotesResultDto>(url, options)
            .pipe(map((response) => plainToClass(WFVendorNotesResultDto, response)));
    }

    saveVendorNotes(baseParams: SaveCommunityVendorNotesParametersDto): Observable<any> {
        return this.httpClient
            .post<string>(`${URLConstants.ccCommunityVendorBaseApiUrl}/notes`, classToPlain(baseParams))
            .pipe(map((responseData: any) => responseData));
    }
}
